module.exports = __webpack_public_path__ + "static/one-pipe-23408f9107e331924f0256a727b2aeff.svg";